import { render, staticRenderFns } from "./TravelLeisure.vue?vue&type=template&id=9fb593c0&scoped=true"
import script from "./TravelLeisure.vue?vue&type=script&lang=js"
export * from "./TravelLeisure.vue?vue&type=script&lang=js"
import style0 from "./TravelLeisure.vue?vue&type=style&index=0&id=9fb593c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb593c0",
  null
  
)

export default component.exports